<template>
  <v-card class="d-flex flex-column main-card">
    <header-assessment
      class="mt-3"
      :data="headerData"
      pl="2vw"
      pr="2vw"
      mb="1vw"
      title="Assesmen Poli Klinik Ibu dan Anak"
    />
    <v-divider></v-divider>
    <div class="content-wrapper">
      <v-row v-if="!isLoading" no-gutters class="fill-height">
        <v-col class="form-container flex-grow-1" style="flex: 1">
          <InputAssessment
            ref="assessment"
            v-if="!emrData"
            @close-form="close()"
            :is-ihs="isIhs"
            :tab="tab"
            :patient-data="patient"
          />

          <!-- EMR -->
          <InputAssessment
            ref="assessment"
            v-else
            @close-form="close()"
            :patient-data="patient"
            :emr-data="emrData"
            :is-ihs="isIhs"
            :is-emr="isEmr"
          />
        </v-col>
        <v-col class="sidebar-container" style="flex: 0.4">
          <history-sidebar
            :header-data="headerData"
            :unit="'Poli KIA'"
            @navigate-to="navigateTo"
          />
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import HistorySidebar from '../AssessmentComponents/HistorySidebarV2.vue';
import InputAssessment from './InputAssessment';
import HeaderAssessment from '../AssessmentComponents/HeaderAssessment.vue';
import formatMixin from '@/mixin/formatMixin';

// import { formatAddress } from '@/helper';
const moment = require('moment');

// api
import { getSocialDataByRmNumber } from '@/fetchApi/patient';

export default {
  mixins: [formatMixin],
  components: {
    HistorySidebar,
    InputAssessment,
    HeaderAssessment,
  },
  data() {
    return {
      headerData: '',
      patient: null,
      isLoading: true,
    };
  },
  props: {
    patientData: {
      type: Object,
      default: null,
    },
    idRegistration: {
      type: String,
      default: null,
    },
    rmNumber: {
      type: String,
      default: null,
    },
    isIhs: {
      type: Boolean,
      default: null,
    },
    isEmr: Boolean,
    emrData: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.getSocialData();
  },
  methods: {
    navigateTo(ref) {
      const el = this.$refs.assessment.$refs[ref];
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
    async getSocialData() {
      try {
        this.isLoading = true;
        const response = await getSocialDataByRmNumber(
          this.patientData?.rmNumber || this.rmNumber,
        );
        this.assignHeaderData(response.data.data);
        this.assignPatientDataForProps(response.data.data);
      } catch {
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
    assignHeaderData(data) {
      this.headerData = [
        {
          label: 'No.RM',
          text: this.patientData?.rmNumber || this.rmNumber,
        },
        {
          label: 'Nama',
          text: `${data.name} (${data.gender ? 'L' : 'P'})`,
        },
        {
          label: 'Tanggal Lahir',
          text: `${moment(data.birth.date, 'YYYY-MM-DD').format(
            'DD/MM/YYYY',
          )} (${this.ageDuration(moment(data.birth.date, 'YYYY-MM-DD'))})`,
        },
        {
          label: 'Hambatan dalam Berkomunikasi',
          text: data.commmunication_obstacles || 'Tidak Ada',
        },
      ];
    },
    assignPatientDataForProps(data) {
      this.patient = {
        rmNumber: this.patientData?.rmNumber || this.rmNumber,
        meta: {
          name: data.name,
          address: this.formatAddress(data.address),
          // poly: this.patientData.meta.poly,
          birthDate: moment(data.birth.date, 'YYYY-MM-DD').format(
            'DD MMMM YYYY',
          ),
          bpjs: {
            number: data.assurance.number,
          },
          age: data.age,
          gender: data.gender,
          guarantorType: data.assurance.type,
          guarantorNumber: data.assurance.number,
          // poly: this.patientData.meta.poly,
          rmNumber: this.patientData?.rmNumber || this.rmNumber,
          // address: formatAddress(data.address),
          poly: 'Poli Kia',
          // address: data.address,
        },
        id_registration:
          this.patientData?.id_registration || this.idRegistration,
        // rmNumber: this.patientData.rmNumber,
      };
    },
    close() {
      this.$emit('close-form');
    },
  },
};
</script>

<style lang="scss" scoped>
.main-card {
  height: 90vh;
  max-height: 700px;
  width: 1200px;
  max-width: 95vw;
}
.content-wrapper {
  flex-grow: 1;
  overflow: hidden;
  height: 100%;
}

.form-container {
  height: 100%;
}

.sidebar-container {
  height: 100%;
}
</style>
